import { Hub, FileType, LogisticNetwork } from '@/types/data';
import { useNetworks } from '@/hooks/useNetworks';
import { useFileData } from '@/hooks/useFileData';

export const useHubsData = (currentNetwork: LogisticNetwork | null) => {
  const { getEditedHubs, autosaveHubs } = useNetworks();

  // Create empty row configuration
  const createEmptyRow = (): Hub => ({
    hub: '-',
    name: '',
    street: '',
    suburb: '',
    state: '',
    postcode: '',
    country_code: '',
    company: '',
  });

  // Use the generic file data hook
  const {
    data: hubs,
    isEdited,
    isSaving,
    addEmptyRow,
    discardChanges,
    handleRowsChange,
    deleteRow,
  } = useFileData<Hub>(currentNetwork, {
    fileType: FileType.Hubs,
    getEditedData: getEditedHubs,
    autosaveData: autosaveHubs,
    createEmptyRow,
  });

  return {
    hubs,
    isEdited,
    isSaving,
    addEmptyRow,
    discardChanges,
    handleRowsChange,
    deleteRow,
  };
};
